/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
window.onload = function () {
  var cu = location.href;
	var sp = cu.split("=");
	var lastSegment = sp.pop() || sp.pop();
        var tv1= 'GLACIER';
		var tv2= 'PEBBLE';
		var tv3= 'LANTERN';
		var tv4= 'BLAZE';
		var tv5= 'EVERGREEN';
		var tv6= 'ONYX';
		var tv7= 'TAKEOFF TEAL';
		var tv8= 'SUMMER FRIDAY FUCHSIA';
		setTimeout(function() {
		if(lastSegment == 41293525286954) {
		$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv1);
		}else if(lastSegment == 41293648527402) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv2);
		}else if(lastSegment == 41293690306602) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv3);
		}else if(lastSegment == 41293736181802) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv4);
		}else if(lastSegment == 41293949501482) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv5);
		}else if(lastSegment == 13788561702954) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv6);
		}else if(lastSegment == 30270974885930) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv7);
		}else if(lastSegment == 30270974033962) {
			$('.product-tushy-travel .product__info .product-form__option-info .product-form__option-name').text(tv8);
		}          
	}, 1000);
  
	var currentUrl = window.location.href;
	if (
		currentUrl ==
		"https://lf49lfcbe6k872tt-8812654.shopifypreview.com/products_preview?preview_key=aa289cf74a1254b6ac565a88ee462aee&variant=40577857716266"
	) {
		window.location.href =
			"https://hellotushy.com/products/copy-of-tushy-classic-3-0?variant=40577857716266";
	} else if (
		currentUrl ==
		"https://hellotushy.com/products/tushy-travel-upsell?variant=31087463268394"
	) {
		window.location.href =
			"https://hellotushy.com/products/tushy-travel-bidet?variant=13788561702954";
	}
              var str = $('#get-c-price').text();
              var clean = str.replace(/[^0-9A-Z]+/gi,"");
              var answer = clean.replace(/[0-9]/g, '');
              if(answer == 'CAD') {
                 $('body').addClass("canada-text-active");
               }
              $('#show-cad-iso').text(answer);
              $(".bundle-product-ele-price").each(function () {
                var parts = $(this).attr('vv-id').split('=');
                parts.pop() || parts.pop();  // handle potential trailing slash
              });
  
};

document.addEventListener("DOMContentLoaded", () => {
	let visitorCountry = sessionStorage.getItem("visitorCountry");
	if (visitorCountry === "CA") {
		var a = location.href;
		var parts = a.split("=");
		var lastSegment = parts.pop() || parts.pop();
		const activeVariant = $(".tushy-picker-option.active").data(
			"variant-name"
		);

		$(".canada-varint-text .variant-message").each(function () {
			var c_id = $(this).attr("data-variant-id");
			if (lastSegment == c_id) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		$(".variant_scroller .variant-swatch-list .variant-swatch").each(
			function () {
				var get_var_id = $(this).attr("data-variant-id");
				if (lastSegment == get_var_id) {
					var c_ship_time = $(this).attr("shipping-time");
					$("#get-ship-time").text(c_ship_time);
				}
			}
		);

		$(".variant-message.canada-only").addClass("selected-variant-name");
		$(".variant-message.canada-only." + activeVariant).show();

		// Hide Sub for Canada
		$("#variant_subscription").addClass("canada");
		document
			.querySelector(
				"#variant_subscription #product-plan-type-subscription"
			)
			?.click();
		//Remove Ottoman Bundle for Canada
		$(".remove-if-canada").remove();
		$("#variant_subscription").hide();
      
	} else {
		$("#variant_subscription").removeClass("canada");

		$(".canada-varint-text .variant-message").each(function () {
			$(this).hide();
		});


	}
	$(".variant-swatch-list .variant-swatch").click(function () {
    var ship_time = $(this).attr("shipping-time");
    var variantQuantity = $(this).attr("varint-qua");
    var variantQuantityPolicy = $(this).attr("varint-qua-policy");
    var check_minus = Math.sign(variantQuantity);
    
    function checkVariantQuantity() {
      if(variantQuantity == 0 && variantQuantityPolicy == 'deny'){
        $('button.product-form__add-button').addClass('sold-out-item');
      } else if(check_minus == -1 && variantQuantityPolicy == 'deny') {
        $('button.product-form__add-button').addClass('sold-out-item');
      } else if(variantQuantity < 0 && variantQuantityPolicy == 'deny') {
        $('button.product-form__add-button').addClass('sold-out-item');
      } else if (variantQuantityPolicy == 'continue') {
        $('button.product-form__add-button').removeClass('sold-out-item');
      }
    }

    checkVariantQuantity();

    setTimeout(checkVariantQuantity, 100);
     
    if (visitorCountry === "CA") {
        $("#get-ship-time").text(ship_time);
    }
	});
  $(".template-product-tushy-travel .variant-swatch-list .variant-swatch .variant-swatch__radio").click(function () {
		var t_t = $(this).attr("value");
        var varint_count_item = $(this).attr("varint-cp");
           setTimeout(function() {
              if(varint_count_item == 0){
                $('.product-form__add-button').addClass('sold-out-item');
              }else{
                $('.product-form__add-button').removeClass('sold-out-item')
              }
             }, 500);
		$('body.collection-products .product__info .product-form__option-info .product-form__option-name').text(t_t);
	});


  $(".tushy-product-container .product__info .product-form__option-selector .variant-swatch-list .variant-swatch").click(function () {
    var v_id = $(this).attr("data-variant-id");
    if (visitorCountry === "CA") {
      $(".canada-varint-text .variant-message").each(function () {
        var c_id = $(this).attr("data-variant-id");
        if (v_id == c_id) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });
});

var pdpmodal = document.getElementById("pdpinfo-myModal");
	$(".page-pdp .product-form .product-form__quick-info .product-form__quick-info-item").click(function(){
	$('#pdpinfo-myModal .modal-content').css("visibility", "visible");
		
	});
// When the user clicks on <span> (x), close the modal
		$('.product-form__quick-info-modal .modal-content .cross-img').click(function () {
		$('#pdpinfo-myModal .modal-content').css("visibility", "hidden");
		$('body').removeClass('pdp-quick_info-modal');
	});

	$('#open-chat-widget').click(function () {
		setTimeout(function() {
			$('.product-form__quick-info-modal .modal-content .cross-img').click ();
		}, 500);
	});

// When the user clicks anywhere outside of the modal, close it
	window.onclick = function(event) {
    if (event.target == pdpmodal) {
      // eslint-disable-next-line no-undef
      modal.style.display = "none";
    }
	}

// Match with currunt attribute of pdp model
$('body.page-pdp .product-form .product-form__quick-info .product-form__quick-info-item').click(function () {
	var c_t = $(this).attr('text-type');
	$("body.page-pdp .product-form .product-form__quick-info-modal").each(function () {
		var t = $(this).attr('type');
		if( c_t == t) {
			var m_tittle = $(this).attr('main-title');
			if((m_tittle == '') || (m_tittle =='undefined') || (m_tittle == null )){
			$(this).hide();
			} else
            {
				$('body').addClass('pdp-quick_info-modal');
				$(this).show();
			}
			
		} else {
			$(this).hide();
		}

	});
});

// Code for 'TUSHY Classic 3.0 Bundle' product change varint name
$(document).ready(function () {
  $(document).on("click",".variant-group-item-wrap .variant-group-item",function () {
        var a = location.href;
		var parts = a.split("=");
		var lastSegment = parts.pop() || parts.pop();
      var bundlevid = $(this).attr("data-vl-variant");
      $(".product-bundle-spa .product-form__option-info span.update_varint_option-name").hide();
      $(".product-bundle-classic .product-form__option-info span.update_varint_option-name").hide();
    
       setTimeout(function () {
         // Code for calulate bidet 'TP' save price
             $("#MainPaymentContainer .alternate-pdp-price").each(function () {
                var get_v_title = $(this).attr("data-variant-id");
                if (bundlevid == get_v_title) {
                  $(this).show();
                }else {
                  $(this).hide();
                }
              });
         
            $('.product-bundle-spa, .product-bundle-classic,  .variant-group-item-wrap .variant-group-item').each(function () {
               $(this).removeClass('selected')
            });

           $(".template-product-bundle-spa .variant-swatch-list .variant-swatch, .template-product-bundle-classic .variant-swatch-list .variant-swatch").each(function () {
            var gi = $(this).attr('data-variant-id');
            
            if(bundlevid == gi){
            $(this).click();
           $(this).addClass('checked');    
           $('.product-form__option-info.classic-spa .product-form__option-name').html( $(this).attr('data-vl-name'));
          }else{
            $(this).removeClass('checked');
          }
         });
        
        $(".product-bundle-spa .product-form__option-info .product_varint_option-name").each(function () {
          var Aid = $(this).attr("pro-bundle");
          if (bundlevid == Aid) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
         $(".product-bundle-classic .product-form__option-info .product_varint_option-name").each(function () {
          var Aid = $(this).attr("pro-bundle");
          if (bundlevid == Aid) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });

        // Code for update bundle template variant images
        $(
          "body.product-bundle-classic, .product-bundle-spa, .product__media .desktop-wrap .parent"
        ).each(function () {
          var vimg = $(this).attr("pv-id");
          if (lastSegment == vimg) {
            $(this).addClass("active").siblings().removeClass("active");
          }
        });
        // Code for update bundle template variant images
        $(
          "body.product-bundle-classic, .product-bundle-spa, .product__media .mobile-wrap .mobile-slider"
        ).each(function () {
          var vimg = $(this).attr("pv-id");
          if (lastSegment == vimg) {
            $(this).addClass("active").siblings().removeClass("active");
          }
        });
      }, 100);
    }
  );
  // Code for update bundle template variant images
  $(document).on("click",".variant-swatch-list .variant-swatch .variant-swatch__radio", function () {
      var inputName = $(this).attr("name");
      var get_c_id = $(this).attr("data-variant-id");
      var v = $(this).val();
      var vi = $(this).attr("varint-qua");
      var check_minus = Math.sign(vi);
      var variantQuantityPolicy = $(this).attr("varint-qua-policy");
      
      setTimeout(function () {
        if(vi == 0 && variantQuantityPolicy == 'deny'){ 
          $('button.product-form__add-button').addClass('sold-out-items');
        }else if( check_minus == -1 && variantQuantityPolicy == 'deny'){
          $('button.product-form__add-button').addClass('sold-out-items');
        }else if (vi > 0 && variantQuantityPolicy == 'deny'){
          $('button.product-form__add-button').removeClass('sold-out-items');
        }
        $(
          ".product-bundle-spa .product-form__option-info span.product-form__option-name"
        ).text(v);
        $(
          ".product-bundle-classic .product-form__option-info span.product-form__option-name"
        ).text(v);
        if(inputName == 'option1'){
          $(".variant-type-ottoman .product-form__option-selector .product-form__option-info span.product-form__option-name").text(v);
        }
         $("#MainPaymentContainer .alternate-pdp-price").each(function () {
          var get_v_title = $(this).attr("data-variant-id");
          if (get_c_id == get_v_title) {
            $(this).show();
          }else {
            $(this).hide();
          }
        });
        
        $("body.product-bundle-classic, .product-bundle-spa, .product__media .desktop-wrap .parent").each(function () {
          var vimg = $(this).attr("pv-id");
          if (get_c_id == vimg) {
            $(this).addClass("active").siblings().removeClass("active");
          }
        });
        $(".product-bundle-spa .product-form__option-info .product_varint_option-name").each(function () {
          var Aid = $(this).attr("pro-bundle");
          if (get_c_id == Aid) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
        $(".product-bundle-classic .product-form__option-info .product_varint_option-name").each(function () {
          var Aid = $(this).attr("pro-bundle");
          if (get_c_id == Aid) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
        $("body.product-bundle-classic, .product-bundle-spa, .product__media .mobile-wrap .mobile-slider").each(function () {
          var vimg = $(this).attr("pv-id");
          if (get_c_id == vimg) {
            $(this).addClass("active").siblings().removeClass("active");
          }
        });
      }, 100);
    });

  // add class 'checked' on radio input button for spa and classic
 setTimeout(function () {
        var u = location.href;
		var f = u.split("=");
		var fSegment = f.pop() || f.pop();
        $('.template-product-bundle-spa .variant-group .variant-group-item-wrap .variant-group-item, .template-product-bundle-classic .variant-group .variant-group-item-wrap .variant-group-item').each(function () {
            var vgi = $(this).attr('data-vl-variant');
            if(fSegment == vgi){
              $(this).click();
            }
        });
  }, 500);
  $(document).on("click",".template-product-bundle-spa .variant-swatch-list .variant-swatch, .template-product-bundle-classic .variant-swatch-list .variant-swatch", function () {
     var v = $(this).attr("data-variant-id");
      setTimeout(function () {
          $(".template-product-bundle-spa .variant-swatch-list .variant-swatch, .template-product-bundle-classic .variant-swatch-list .variant-swatch").each(function () {
            var gi = $(this).attr('data-variant-id');
            if(v == gi){
           $(this).addClass('checked');
           $('.product-form__option-info.classic-spa .product-form__option-name').html( $(this).attr('data-vl-name'));
          }else{
            $(this).removeClass('checked');
          }
         });
     }, 300);
  });
});

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 30) {
    $("body").addClass("sticky-search");
  } else {
    $("body").removeClass("sticky-search");
  }
});


$(document).ready(function () {
  $('.header-search').click(function () {
    $('body').toggleClass('popup-header-search');
  });
  $('.search-popup-cross').click(function () {
    $('body').removeClass('popup-header-search');
  });


  // Predictive Search script
  $('#right-side-content .default-search-wrapper.default-se-hard-element').addClass('remove-default-item');
  
  $("#predictive-search__input-custom").keydown(function () {
    setTimeout(function () {
      var c_cl = $('input#predictive-search__input-custom').hasClass("is-filled");

      if (c_cl == true) {
        $('.default-search-wrapper.default-se-hard-element').addClass('remove-default-item');
        $('#right-side-content .homepage-blog-section').addClass('remove-default-item');
        $('#right-side-content .default-search-wrapper.default-se-hard-element').removeClass('remove-default-item');
      } else if (c_cl == false) {
        $('.default-search-wrapper.default-se-hard-element').removeClass('remove-default-item');
        $('#right-side-content .homepage-blog-section').removeClass('remove-default-item');
        $('#right-side-content .default-search-wrapper.default-se-hard-element').addClass('remove-default-item');
      }
  }, 500);
  });


  $("#search-drawer .search-popup-flex_box .drawer__header .predictive-search__form button.main-search__submit.tap-area").click(function(){
     var c_cl = $('input#predictive-search__input-custom').hasClass("is-filled");
     var checkcl = $('#search-drawer .search-popup-flex_box .drawer__content .update-search .predictive-search__results h3.text--large').hasClass("predictive-search-f");
     if (c_cl == false){
        return false;
     } else if (checkcl == true) {
        return false;
       
     }
  });
  
});


// Code for home page and shop page change variant images
$(document).ready(function(){
  
  var vp = $('.template-index .index-bundle-element, .page-shop-all-c .index-bundle-element').attr('vp');
  var comp = $('.template-index .index-bundle-element, .page-shop-all-c .index-bundle-element').attr('comp');
  $('.index-default #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product--featured #variant_price_add_button .price-list .price.price--compare').text(comp);
  $('.index-default #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product--featured #variant_price_add_button .price-list .original-variant-price').text(vp);
  
  $('[loop-count="3"]').hide(); 
  $('[loop-count="4"]').hide(); 
  $('[loop-count="5"]').hide(); 
  $('[loop-count="6"]').hide(); 


  $('.template-page-Gottogo .black-dealy-cl').css('visibility', 'visible');
   $('.page-shop-all-c .black-dealy-cl').css('visibility', 'visible');
  $(".template-index input.block-swatch__radio, .page-shop-all-c input.block-swatch__radio").click(function(){

    var alt = $(this).val();
    $(".template-index #ace-electric-bidet .swiper.mySwiper.black-v-images.black-dealy-cl, .page-shop-all-c #ace-electric-bidet .swiper.mySwiper.black-v-images.black-dealy-cl").each(function(){
      var thumb_alt = $(this).attr('v-title');
      if( alt == thumb_alt){ 
        $(this).addClass('firstcl');
      }else{
        $(this).removeClass('firstcl');
      }
    });
  });

  $(".template-index input.color-swatch__radio, .page-shop-all-c input.color-swatch__radio").click(function(){
    var alt = $(this).val();
    $(".template-index #tushy-classic-3-0-bundle .swiper.mySwiper.black-v-images.black-dealy-cl, .page-shop-all-c #tushy-classic-3-0-bundle .swiper.mySwiper.black-v-images.black-dealy-cl").each(function(){
      var thumb_alt = $(this).attr('v-title');
      if( alt == thumb_alt){ 
        $(this).addClass('firstcl');
      }else{
        $(this).removeClass('firstcl');
      }
    });
  });

  $(".template-index .index-bundle-element, .page-shop-all-c .index-bundle-element").click(function(){
     var bv = $(this).attr('data-vl-target');
      var vp = $(this).attr('vp');
      var comp = $(this).attr('comp');
      var b_t = $(this).attr('title');
     $('.index-default #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product--featured #variant_price_add_button .price-list .price.price--compare').text(comp);
     $('.index-default #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product--featured #variant_price_add_button .price-list .original-variant-price').text(vp);
     $('.template-index #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product-form .product-form__option-info span.product-form__option-value').text(b_t);
     $('.template-index #shopify-section-template--15803374698538__go_travel_featured_product_TEBCTw .product-form .product-form__option-info span.product-form__option-value').text(b_t);
    
      if(bv == 'single'){
        $('[loop-count="1"]').show(); 
        $('[loop-count="2"]').show();
        $('[loop-count="3"]').hide(); 
        $('[loop-count="4"]').hide(); 
        $('[loop-count="5"]').hide(); 
        $('[loop-count="6"]').hide(); 
        

      }else if (bv == 'twopack') {
        $('[loop-count="3"]').show(); 
        $('[loop-count="4"]').show();
        $('[loop-count="1"]').hide(); 
        $('[loop-count="2"]').hide(); 
        $('[loop-count="5"]').hide(); 
        $('[loop-count="6"]').hide(); 

        
      }else if (bv == 'bundle') {
        $('[loop-count="5"]').show(); 
        $('[loop-count="6"]').show();
        $('[loop-count="1"]').hide(); 
        $('[loop-count="2"]').hide(); 
        $('[loop-count="3"]').hide(); 
        $('[loop-count="4"]').hide(); 
      }
   $(".template-index .color-swatch-list .color-swatch input.color-swatch__radio, .page-shop-all-c .color-swatch-list .color-swatch input.color-swatch__radio").each(function(){
     var blc = $(this).attr('value');
      if(b_t==blc){ 
        setTimeout(() => {
          $( this ).attr( 'checked', true );
          $( this ).click();
        }, 500);
      }
   });
   });
  $(".product-scent .variant-swatch-list .variant-swatch input.variant-swatch__radio, .product-daily-room-spray .variant-swatch-list .variant-swatch input.variant-swatch__radio, .product-before-go-toilet-spray .variant-swatch-list .variant-swatch input.variant-swatch__radio").click(function(){
    var pvid = $(this).attr('product-v-id');
    var pv = $(this).attr('value');
    $('.variant-type-ottoman .product-form__option-info span.product-form__option-name').text(pv);
      $(".product-scent .product__media .desktop-wrap .parent, .product-daily-room-spray .product__media .desktop-wrap .parent, .product-before-go-toilet-spray .product__media .desktop-wrap .parent").each(function(){
        var vid = $(this).attr("pv-id");
        if(pvid==vid){ 
          $(this).addClass("active").siblings().removeClass("active");
        }
      });
      });
   // Code for add text 'predorder on subcription'
   $("input.variant-swatch__radio.visually-hidden").click(function(){
       var g_pre = $(this).attr('value');
       var sdate = 'Ships on 7/9';
       var pre_t = 'Pre-Order';
      setTimeout(() => {
           if((g_pre == 'PRE-ORDER EVENING WOOD') || ( g_pre == 'PRE-ORDER AFTERNOON DIP')){
                $('span.pdp-pre-order').text(sdate);
                $('.product__info .product-form__add-button span.loader-button__text').text(pre_t);
             }else{
                 $('span.pdp-pre-order').text('');
                 $('.product__info .product-form__add-button .loader-button__text').text('ADD TO CART');
            }
        }, 700);
     
     });
  
  });

$(document).ready(function(){
 
  
  $("#predictive-search__input-custom").keyup(function(){
    setTimeout(() => {
    var checksadasdcl = $('#search-drawer .search-popup-flex_box .drawer__content .update-search .predictive-search__results h3.text--large').hasClass("predictive-search-f");
      if(checksadasdcl == true){
       $('#view-all-reslut-btn').addClass('vablink');
      }else{
        $('#view-all-reslut-btn').removeClass('vablink');
      }
    }, 1000);
 });

 $('body.product-30-classic-eko .variant-swatch').click(function(){
       var eko_pils_btn = $(this).attr('varint-q');
       $('span#variant_price_add_button span.price.price--compare').html(eko_pils_btn);
  });
  
  $(".product-30-classic-eko .variant-group-item-wrap .variant-group-item").click(function(){
    var pils_btn = $(this).attr('data-vl-variant');
    $('.product-form__option-info.classic-spa .product-form__option-name').html( $(this).attr('data-vl-name'));
    setTimeout(() => {
    $(".product-30-classic-eko .variant-swatch-list.classic-spa.active .variant-swatch").each(function(){
     var v_itm_id = $(this).attr('data-variant-id');
       if(pils_btn == v_itm_id){ 
             var get_vp = $(this).attr('varint-price');
             var vcp = $(this).attr('varint-q');
         
             $('.product-30-classic-eko .product__info .product-form__buy-buttons .price--highlight .p-v-s-p').html(get_vp);
             $('.product-30-classic-eko .product__info .product-form__buy-buttons .price--compare .money').html(vcp);
          }
     });
    }, 1000);
    
  });  
  $(".product-form__quick-info-item.triger-quiz-compatibility").click(function(){
      $('span#quizmyBtn').trigger( "click" );
  });
  $("p#check-compatibility").click(function(){
       $('span#quizmyBtn').trigger( "click" );
  });
  $("li.mobile-nav__item.custom-Check.Compatibility-mobile").click(function(){
    $('button.drawer__close-button.drawer__close-button--block.tap-area').trigger( "click" );
    $('span#quizmyBtn').trigger( "click" );
  });

//   window.addEventListener('load', function() {
//   const bidetStoolButton = document.querySelector('.template-product-sl-1A9F571A .variant-group-item[data-vl-target="Bidet + Stool"]');
//   if (bidetStoolButton) {
//     bidetStoolButton.click(); // Simulate a click event on the "Bidet + Stool" button
//   }
// });

  
});

// End Here
// window.onload = function() {
//   // Find the element with class 'variant-group-item-wrap bidet-stool'
//   let targetElement = document.querySelector('.template-product-sl-1A9F571A .variant-group-item-wrap.bidet-stool .variant-group-item');
//   if (targetElement) {
//     setTimeout(() => {
//     targetElement.click();
//       }, 1000);
//   }
// };
 $(".product-sl-ACD8A3AC .variant-group-item-wrap.bidet-travel").click(function(){
   $(".product-sl-ACD8A3AC .variant_scroller-wrap .variant_scroller .variant-swatch-list.classic-spa").each(function(){
     var get_abpdp_item = $(this).attr('data-vl');
      get_abpdp_item = get_abpdp_item.trim();
     if(get_abpdp_item == 'Bidet + Travel'){
       setTimeout(() => {
        $(this).addClass('active');
     }, 500);
     }
   });
  });

//Code for add compare (stripe price) on tusy stand pdp
$(".tushy-product-container #variant_subscription .product-plan-type-onetime").change(function(){
    var gv = $(this).attr('single-v-option');
   var currentLocation = window.location;
  if( currentLocation == 'https://hellotushy.com/products/tushy-stand'){
     var getvphard = $('#variant-subs .variant-subs-elem').attr('vp');
    setTimeout(() => {
     $('#variant_price_add_button .surprice.price--compare .com-p-elem').html(getvphard);
      }, 500);
  }else{
      $("#variant-subs .variant-subs-elem").each(function () {
         var subsvid = $(this).attr('variant-id');
         if(gv == subsvid ){
           var getvp = $(this).attr('vp');
           $('#variant_price_add_button .surprice.price--compare .com-p-elem').html(getvp);
         }
      });
  }  
});


   // Code for add addons click on add to cart
    $("input.pdp-subscription-cart").click(function(){
      $(this).toggleClass("pdp-subscription-add-to-cart");
    });

   $(".product-form__add-button.sticky-add-to-cart").click(function(){
    
    var check_subs_ele = $("input.pdp-subscription-cart").hasClass("pdp-subscription-add-to-cart");
    var ID = $("input.pdp-subscription-cart-hidden").val();
    var sellingPlan = $("input.pdp-subscription-cart-hidden").attr('data-sellingplan');

    
  
    var quantity = 1;
    if(check_subs_ele == true) {
     setTimeout(() => {
      
       $.ajax({
            type: 'POST',
            url: '/cart/add.js',
              data: 'quantity='+quantity+'&id='+ID+'&selling_plan='+sellingPlan,
              dataType: 'json', 
              success: function () { },
              error: function () { }  
       });
      }, 500);
    }        
   });

// New Bidet Collection updates
/*--- Bidet Collection Collapsible Section---*/
$(".bidet-collapsible-section .collapsible-toggle").click(function () {
   if ($(this).attr('aria-expanded') == "true") {
    let dataID = $(this).attr('aria-controls');
    $(".bidet-collapsible-section .collapsible-toggle").attr('aria-expanded','false');
    $(".bidet-collapsible-section collapsible-content").removeAttr('open');
    $(this).attr('aria-expanded','true');
    $(this).next('collapsible-content').attr('open',"true");
    $('.collapsible-img-box .media_wrap').each(function(){
      let dataIdImg = $(this).attr('data-id');
      if(dataID == dataIdImg){
        $('.collapsible-img-box .media_wrap').removeClass('active');
        $(this).addClass('active');
      }
    })
   }
});
/*---END---*/

/*--- Bidet Collection new NAV BAR---*/
// NAV BAR visibility
$(window).on('scroll', function () {
  var $target = $('#new-bidet-main-banner');

  if ($target.length) {
    var scrollTop = $(window).scrollTop();
    var targetOffset = $target.offset().top - 20;
    var targetHeight = $target.outerHeight();
    var windowHeight = $(window).height();
 
    // Check if the element is within the viewport
    if (scrollTop + windowHeight >= targetOffset && scrollTop <= targetOffset + targetHeight) {
      $('body').removeClass('bidet-nav-visible');
    } else {
      $('body').addClass('bidet-nav-visible');
    }
  }
});

// Adding Active class to NAV MENU
function updateNav(el){
  let hrefName;
  $('#collection-sticky-nav_new .nav-left a').each(function(){
    hrefName = $(this).attr('href').split('#');
    if(el == hrefName[1]){
      $('#collection-sticky-nav_new .nav-left a').removeClass('active');
      $(this).addClass('active');
    }
  })
}

$('#collection-sticky-nav_new .nav-left a').click(function(){
  let attrHref = $(this).attr('href').split('#');
  updateNav(attrHref[1]);
});

$(document).ready(function(){
  let url = window.location.href;
  let path = url.split('#');  
  if(path[1]){
    updateNav(path[1]);
  };
  
  // Scroll to TOP
  $('#collection-sticky-nav_new #scroll_up').click(function(){
     window.scrollTo({
        top: 0,
        behavior: 'smooth' 
     });
  });
  
  // Scroll to Comaprison Chart
  $('#collection-sticky-nav_new #compare_bidets_btn').click(function(){
    const targetEl = document.getElementById('collection-comparison-chart');
    targetEl.scrollIntoView({
      behavior: 'smooth'
    });
  });
                                                            
});
/*---END---*/

/*--HP: Second section HP:Animated Icon & Content Modal script--*/
$('.animated-icons-with-content .feature-modal-open').click(function () {
  var c_t = $(this).attr('text-type');
  $(".animated-icons-with-content .product-form__quick-info-modal").each(function () {
    var t = $(this).attr('type');
    if( c_t == t) {
      $('body').addClass('pdp-quick_info-modal');
      $(this).css("display", "flex");
      $('#pdpinfo-myModal .modal-content').css("visibility", "visible");
      // Play video 
       var video_ = $(this).find('video.tolstoy-hero-video')[0];
        if (video_) {
          video_.currentTime = 0;
          video_.play();
        }
    } else {
      $(this).css("display", "none");
    }
  });
});

$('.animated-icons-with-content .modal .cross-img').click(function () {
  var video = $(this).closest('.modal-content').find('video')[0];
  if (video) {
    video.pause();
  }
});
/*---END---*/

/*---ACE PDP VARIANT SELECTION---*/
if($('#AddToCart').hasClass('button-disabled')){
  $('#notifination-message-4variant').html(`<span id="p-shape-variant">Please confirm toilet bowl shape</span>`);
}

$('.variant-swatch__radio.visually-hidden').click(function(){
  if ($('.variant-swatch__radio.visually-hidden').is(':checked')) {
    $('#AddToCart').removeClass('button-disabled');
    $('#p-shape-variant').hide();
  }
})
/*---END---*/


